import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import appContext from '../../Context/appContext';
import { setSearchState } from '../../redux/slices/searchSlice';

const RecentSearch = ({ recentSearches, removeRecentSearch, setNewRecentSearchValue }) => {
  // const { dispatch } = useContext(appContext);
  const dispatchRedux = useDispatch()

  return (
    <div className="my-4 mb-lg-5 mt-lg-0">
      <h5 className="recent-search-text">Recently Searched by You</h5>
      <div className="d-flex mobile-scroll-pills">
        {recentSearches?.map(item => (
          <div key={item} className="search-pill">
            <i className="icon icon-search-pill pr-2" />
            <span
              onClick={() => {
                // dispatch({ type: 'setSearchState', payload: item });
                dispatchRedux(setSearchState(item))
                setNewRecentSearchValue(item);
              }}
              className="pr-3 cursor-pointer"
            >
              {item}
            </span>
            <button className="btn btn-sm s-close-btn p-0">
              <i className="icon icon-close bold" onClick={() => removeRecentSearch(item)} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentSearch;
